import * as Constants from '../constants';

const initialState = { isLoggedIn: false, loading: false };
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.AGENT_LOGIN_START:
    case Constants.SSO_LOGIN_START:
      return Object.assign({}, state, { data: state.data, isLoggedIn: false, loading: true });
    case Constants.AGENT_LOGIN_SUCCESS:
    case Constants.SSO_LOGIN_SUCCESS:
      return Object.assign({},
        state,
        action.data,
        {
          isLoggedIn: true,
          loading: false,
          email: action.data.data.userEmail,
        });

    case Constants.AGENT_LOGIN_FAILURE:
    case Constants.SSO_LOGIN_FAILURE:
      return Object.assign({}, state, action.data, { isLoggedIn: false, loading: false });
    default:
      return { ...state };
  }
}
